import {Grid, Typography} from "@material-ui/core";
import TableESim from "../../../../../../ui/tables/table-e-sim/TableESim";
import {riepilogoHeadCells} from "../invia-di-nuovo-email-first-step/InviaDiNuovoEmailFirstStepHelper";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import EmptyRow from "../../../../../../ui/tables/rows/empty-row/EmptyRow";
import Button from "@material-ui/core/Button";
import {GetApp} from "@material-ui/icons";
import {useDispatch, useSelector} from "react-redux";
import {exportDistribuzioneEsimCsv} from "../../../../../../../store/e-sim/actions";

const InviaNuovoEmailSecondStep = (props) => {
    const dispatch = useDispatch()
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId)

    const handleScaricaClick = () => {
        const esimCsvExportDigitalkitsItems = props.tableData.map((item) => (
            {
                esimSelezionate: item.numeroDiTelefono,
                emailAssociata: item.indirizzoEmail ?? ""
            }
        ))
        const dtoBody = {
            integrationId,
            esimCsvExportDigitalkitsItems
        }
        dispatch(exportDistribuzioneEsimCsv(dtoBody))
    }

    const tableRows = (
        props.tableData.length !== 0 ? props.tableData.map((row) => {
            return (
                <TableRow
                    hover tabIndex={-1}
                    key={"esim-selected-table-row-id" + row.id}>
                    <TableCell style={{border: '0.5px solid #e0e0e0'}}
                               align="left">{row.numeroDiTelefono ? row.numeroDiTelefono : row.seriale}</TableCell>
                    <TableCell style={{border: '0.5px solid #e0e0e0'}}
                               align="left">{row.indirizzoEmail}</TableCell>
                </TableRow>
            );
        }) : <EmptyRow text="dati" colSpan={riepilogoHeadCells.length}/>
    )
    return (
        <Grid container>
            <Typography variant='body1'>
                Controlla nella tabella di riepilogo se i dati associati sono corretti.
            </Typography>

            <Grid item xs={12} style={{padding: '2em 0 1em 0'}}>
                <Typography variant="overline">elenco esim/email</Typography>
            </Grid>

            <Grid item xs={12} style={{paddingBottom: '2em'}}>
                <TableESim headCells={riepilogoHeadCells}
                           tableRows={tableRows}
                           loading={false}
                           showPagination={false}/>
            </Grid>

            <Grid item xs={12} style={{paddingBottom: '2em'}}>
                <Typography variant='body1'>
                    Se vuoi conservare una copia locale dei dati di cui sopra scarica il file .csv.
                </Typography>
            </Grid>

            <Grid item>
                <Button
                    startIcon={<GetApp color={"primary"}/>}
                    variant={"text"}
                    onClick={() => handleScaricaClick()}
                    color={"primary"}>
                    scarica .csv
                </Button>
            </Grid>
        </Grid>
    )
}

export default InviaNuovoEmailSecondStep;